import { SystemTime } from 'types';

/* tslint:disable:no-bitwise */

// Helper function to convert from Win32 SYSTEMTIME binary structure to something more useful
// Note: this is used for conveying timezone information, which uses SYSTEMTIME differently.
// https://msdn.microsoft.com/en-us/library/windows/desktop/ms725481(v=vs.85).aspx
export const parseWin32SystemTime = (base64data: string): SystemTime | null => {
    // The server transmits the binary data in base64... so decode that first.
    if (!base64data) return null;
    const data = atob(base64data);
    const bytes = [];
    for (let i = 0; i < data.length; i++) {
        bytes.push(data.charCodeAt(i));
    }
    if (bytes.length < 10) return null;

    // Note: time is relative to the server
    /* This is what it *should* be based on MSDN docs
    const year = (bytes[1] << 16) | bytes[0]; // 0 means all years
    const month = (bytes[3] << 16) | bytes[2];
    const dayOfWeek = bytes[5];
    const weekOfMonth = bytes[7];
    const hour = (bytes[9] << 16) | bytes[8];
    const minute = (bytes[11] << 16) | bytes[10];
    // seconds and milliseconds are ignored
    */

    // This is what it appears to be according to my registry
    const year = (bytes[1] << 16) | bytes[0]; // 0 means all years
    const month = bytes[2];
    const dayOfWeek = bytes[3];
    const weekOfMonth = bytes[4];
    const hour = (bytes[7] << 16) | bytes[6];
    const minute = (bytes[9] << 16) | bytes[8];

    // Reject invalid input rather than output bogus values
    if (year < 0 || year > 2999) return null; // Y3K bug!!
    if (month < 1 || month > 12) return null;
    if (dayOfWeek < 0 || dayOfWeek > 6) return null;
    if (weekOfMonth < 1 || weekOfMonth > 5) return null;
    if (hour < 0 || hour > 23) return null;
    if (minute < 0 || minute > 59) return null;

    return { year, month, dayOfWeek, weekOfMonth, hour, minute };
};


// WEBPACK FOOTER //
// ./src/sagas/server/parseWin32SystemTime.ts